module.exports = __webpack_public_path__ + "static/media/icon-help-round.8e42f466.svg";